import { CertificateType, PaginatedHoldingsQuery, RegistryCode, VintageHalf } from "@/app/types/generated/graphql";

export const demoHoldings = [
  {
    id: "19da47e9-be5e-4f83-9609-62102144415f",
    availableBalance: 1043,
    currentBalance: 1043,
    project: "Chipmunk-Solar",
    registryCode: RegistryCode.Mrets,
    attributes: {
      __typename: "MretsRecAttributes",
      vintage: 2021,
      location: "OH",
      fuelSources: ["BSW"],
      project: "Chipmunk-Solar",
      certificateType: CertificateType.R,
      eligibilities: ["sd"],
      certifications: ["CRS"],
      commencementDate: "2003-12-21",
      vintageHalf: "FRONT_HALF",
    },
  },
  {
    id: "d6c59493-a881-4a6e-87c5-9c4af3e37d52",
    availableBalance: 1935,
    currentBalance: 1935,
    project: "Nobles-Wind",
    registryCode: RegistryCode.Mrets,
    attributes: {
      __typename: "MretsRecAttributes",
      vintage: 2021,
      location: "MN",
      fuelSources: ["H2O"],
      project: "Nobles-Wind",
      eligibilities: ["wi_non_bankable"],
      certifications: ["CRS"],
      certificateType: CertificateType.R,
      commencementDate: "2003-12-21",
      vintageHalf: "BACK_HALF",
    },
  },
];

export const demoHoldingsErcot: PaginatedHoldingsQuery["paginatedHoldings"]["holdings"] = [
  {
    id: "521ccb41-bb6d-4306-a7c5-4efb398cad9c",
    availableBalance: 11,
    currentBalance: 11,
    project: "ER0001",
    registryCode: RegistryCode.Ercot,
    attributes: {
      __typename: "ErcotRecAttributes",
      vintage: 2024,
      vintageHalf: VintageHalf.Q2,
      fuelSources: ["GT"],
      project: "ER0001",
      certifications: ["CRS"],
      location: "TX",
      certificateType: CertificateType.R,
      commencementDate: null,
    },
  },
];
